import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '~gql';

export const PUBLIC_GROUP = graphql(`
  query PublicGroup($id: ID!) {
    publicGroup(groupIDoLID: $id) {
      id
      linkId
      title
      description
      visibility
      genderPolicy
      ageRange {
        min
        max
      }
      scheduledAt
      archivedAt
      maxSize
      memberCount
      members {
        id
        hidden
        isVerified
        user {
          id
          username
          fullName
          age
          isVerified
          avatarUrl
          personalityCode
          interests {
            id
            name
          }
        }
      }
      spot {
        id
        name
        address
        type
        coordinates {
          latitude
          longitude
        }
      }
    }
  }
`);

export type PublicGroupData = ResultOf<typeof PUBLIC_GROUP>;
export type PublicGroupVars = VariablesOf<typeof PUBLIC_GROUP>;
export type PublicGroup = NonNullable<PublicGroupData['publicGroup']>;
export type PublicMember = PublicGroup['members'][number];
export type PublicUserPreview = NonNullable<PublicMember['user']>;
export type PublicInterest = PublicUserPreview['interests'][number];
export type PublicSpot = NonNullable<PublicGroup['spot']>;
